var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 35C27.3888 35 35 27.3888 35 18C35 8.61116 27.3888 1 18 1C8.61116 1 1 8.61116 1 18C1 27.3888 8.61116 35 18 35Z",
    fill: "url(#paint0_radial_1394_14428)",
    stroke: "#E0E0E0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9434 24.0691C15.0602 24.1845 15.2178 24.249 15.3816 24.25M14.9434 24.0691C14.9432 24.0689 14.943 24.0687 14.9428 24.0685L15.3816 24.25M14.9434 24.0691C14.8852 24.0122 14.8388 23.9443 14.807 23.8693C14.7751 23.7939 14.7586 23.7129 14.7586 23.631C14.7586 23.5491 14.7751 23.4681 14.807 23.3928C14.8389 23.3176 14.8854 23.2496 14.9437 23.1926C14.9438 23.1925 14.944 23.1924 14.9441 23.1923L20.7384 17.5043L14.9461 11.8171C14.8864 11.7614 14.8381 11.6944 14.8044 11.6198C14.77 11.5438 14.7515 11.4615 14.7501 11.378C14.7487 11.2945 14.7644 11.2117 14.7962 11.1346C14.828 11.0574 14.8751 10.9876 14.9346 10.9293C14.994 10.8709 15.0645 10.8252 15.1418 10.7945C15.2191 10.7638 15.3018 10.7487 15.3849 10.7501C15.468 10.7514 15.5501 10.7692 15.6263 10.8024C15.7011 10.835 15.769 10.8819 15.8258 10.9406L22.0633 17.0649C22.0635 17.0652 22.0637 17.0654 22.064 17.0656C22.1225 17.1225 22.1692 17.1904 22.2012 17.2656C22.2334 17.341 22.25 17.4222 22.25 17.5043C22.25 17.5864 22.2334 17.6676 22.2012 17.7431L21.9712 17.6451M14.9434 24.0691L21.9712 17.6451M15.3816 24.25C15.4641 24.2507 15.5461 24.2348 15.6225 24.2034C15.6982 24.1721 15.767 24.1261 15.8247 24.0678L22.0633 17.9437C22.0635 17.9435 22.0637 17.9433 22.064 17.9431C22.1225 17.8862 22.1692 17.8183 22.2012 17.7431L21.9712 17.6451M15.3816 24.25C15.3817 24.25 15.3818 24.25 15.3819 24.25L15.3834 24L15.3811 24.25C15.3812 24.25 15.3814 24.25 15.3816 24.25ZM15.3816 24.25L21.9712 17.6451",
    fill: "#04091F",
    stroke: "#04091F",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1394_14428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9134 11.2664) scale(24.9918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D2D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCircle);
export default __webpack_public_path__ + "static/media/white-circle.bd61e457443ca487e401cae4b9c2e0b5.svg";
export { ForwardRef as ReactComponent };